import React from "react";
import "./ConfirmCreateModal.css";

export default function ConfirmCreateModal({
    isOpen,
    message = "Bạn có chắc chắn muốn thực hiện hành động này?",
    onConfirm,
    onCancel
}) {
    if (!isOpen) return null;

    return (
        <div className="confirm-create-overlay" onClick={onCancel}>
            <div className="confirm-create-modal" onClick={(e) => e.stopPropagation()}>

                <div className="confirm-create-title">Thông báo</div>

                <div className="confirm-create-message">
                    {message}
                </div>

                <div className="confirm-create-actions">
                    <button className="confirm-create-btn-primary" onClick={onConfirm}>
                        Xác nhận
                    </button>

                    <button className="confirm-create-btn-secondary" onClick={onCancel}>
                        Quay lại
                    </button>
                </div>
            </div>
        </div>
    );
}
